import { Component } from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>'
})

export class TestGroupComponent {
}


// WEBPACK FOOTER //
// ./app/admin/testgroup/admin.testgroup.component.ts